import { getDecodedInstance } from '../getDecodedInstance/getDecodedInstance';
export function isTemplateMode(_ref) {
  var _getDecodedInstance;
  let {
    wixCodeApi,
    appParams
  } = _ref;
  return !!((_getDecodedInstance = getDecodedInstance({
    wixCodeApi,
    appParams
  })) != null && _getDecodedInstance.siteIsTemplate);
}
//# sourceMappingURL=isTemplateMode.js.map